import { Chart } from '@antv/g2'
import { CreateElement } from 'vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { g2DefaultCfg } from './config'
import { G2BaseChartData } from '@/types/common/g2Charts'

import { handleType } from './core/chart'
@Component
export default class BarLine extends Vue {
  @Prop({ default: 500 }) height!: number;
  @Prop() options!: any;
  @Prop() type!: string;
  @Prop() slider!: boolean;
  @Prop() values!: G2BaseChartData[];
  id = 'chart' + (Math.floor(Math.random() * 1000000) + 1);
  render (h: CreateElement) {
    return h('div', {
      attrs: {
        id: this.id
      }
    })
  }

  mounted () {
    setTimeout(() => {
      this.chart()
    })
  }

  chart () {
    const { chartCfgFn } = g2DefaultCfg
    const { values, options, slider, type } = this
    const chart = new Chart({
      container: this.id,
      ...chartCfgFn()
    })
    chart.legend(false)
    chart.data(values)
    handleType(chart, { options, values, slider, type }).render()
  }
}
